import { TranslationLabels } from '@generated/translation-labels';
import { useApi, useCountry } from '@shared/hooks';
import React, { FC, useCallback } from 'react';
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import { Content, Elements } from '../../shared';
import { RouteParams } from '../service-request.type';
import { api } from './items.repository';
import { stepper } from '../stepper.config';

export const Items: FC = () => {
  const country = useCountry();
  const { areaId, roomId } = useParams<RouteParams>();
  const { pathname } = useLocation();
  const getItems$ = useCallback(
    () => api.getItems$(country, Number(areaId), pathname, Number(roomId)),
    [areaId, country, pathname, roomId],
  );
  const [response, isFetching] = useApi(undefined, getItems$);

  return (
    <Content
      introProps={{
        descriptionKey: TranslationLabels.ticketingServiceRequestItemsText,
        titleKey: TranslationLabels.ticketingServiceRequestItemsTitle,
      }}
      isFetching={isFetching}
      stepperConfig={stepper}
    >
      <Elements
        data={response?.items}
        otherElementRedirectURL={response?.otherElementRedirectURL}
      />
    </Content>
  );
};
